import { useState } from "react";
import { Input } from "@/components/Inputs";
import axios from "axios";
import { toast } from "react-toastify";
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";

export default ({ closeAuthModal, redirect }) => {
    const { login } = useAuth();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [loginForm, setLoginForm] = useState(true);
    const [fname, setFname] = useState("");
    const [lname, setLname] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [password, setPassword] = useState("");

    const onLogin = async (e) => {
        e.preventDefault();
        if (!email) return toast.error("Email Required");
        if (!password) return toast.error("Password Required");
        try {
            setIsLoading(true);
            const res = await axios({
                method: "post",
                url: process.env.REACT_APP_API_URL + "/CustomerAccounts/OnlineOrderingAuthenticate",
                data: { email, password },
                headers: { "content-type": "application/x-www-form-urlencoded" },
            });
            if (res?.data?.code === 400) return toast.error("Invalid credentails");
            if (res?.data?.code >= 300) return toast.error("Please try again later");
            const user = res.data.data;
            login(user.authToken, {
                userId: user.customerID,
                fname: user.firstName,
                lname: user.lastName,
                phone: user.phone,
                email: email,
                address: user.address,
            });
            toast.success("login successfull");
            closeAuthModal();
            setEmail("");
            setPassword("");
            if (redirect) navigate(redirect, { replace: true });
        } catch (error) {
            toast.error(error?.response?.statusText || "Authentication failed");
        } finally {
            setIsLoading(false);
        }
    };

    const onSignup = async (e) => {
        e.preventDefault();
        if (!email) return toast.error("Email Required");
        if (!fname) return toast.error("Missing First Name");
        if (!lname) return toast.error("Missing Last Name");
        if (!phone) return toast.error("Missing Phone Number");
        if (!password) return toast.error("Password Required");
        try {
            setIsLoading(true);
            const res = await axios({
                method: "post",
                url: process.env.REACT_APP_API_URL + "/CustomerAccounts/CustomerRegistration",
                data: { firstName: fname, lastName: lname, email, phone, address, city, country, postalCode, password },
                headers: { "content-type": "application/json" },
            });
            if (res?.data?.code === 400) return toast.error("Account already exists");
            if (res?.data?.code >= 300) return toast.error("please try again later");
            toast.success("Regestration successfull");
            setPhone("");
            setFname("");
            setLname("");
            setLoginForm(true);
        } catch (error) {
            toast.error(error || "Registration failed");
        } finally {
            setIsLoading(false);
        }
    };

    return loginForm ? (
        <form onSubmit={onLogin} className="flex flex-wrap w-fit">
            <h2 className="w-full p-2 font-semibold text-lg md:text-xl lg:text-2xl">Login</h2>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Email address" />
            <Input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder="Password"
            />
            <p className="p-2 text-xs sm:text-sm md:text-base w-full text-center">
                don't have an account{" "}
                <span
                    className="text-primary cursor-pointer"
                    onClick={() => {
                        setLoginForm(false);
                        setPassword("");
                    }}
                >
                    Signup
                </span>{" "}
                instead.
            </p>
            <button
                disabled={isLoading}
                type="submit"
                className="bg-primary hover:bg-secondary text-white rounded-lg p-2 my-4 w-full font-semibold text-center"
            >
                {isLoading ? "Authentacating..." : "Login"}
            </button>
        </form>
    ) : (
        <form onSubmit={onSignup} className="flex flex-wrap w-fit">
            <h2 className="w-full p-2 font-semibold text-lg md:text-xl lg:text-2xl">Signup</h2>
            <Input
                value={fname}
                onChange={(e) => setFname(e.target.value)}
                width="w-1/2"
                type="text"
                placeholder="First name"
            />
            <Input
                value={lname}
                onChange={(e) => setLname(e.target.value)}
                width="w-1/2"
                type="text"
                placeholder="Last name"
            />
            <Input value={phone} onChange={(e) => setPhone(e.target.value)} type="number" placeholder="Mobile number" />
            <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Email address" />
            <Input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder="Password"
            />
            {/* <Input
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                type="address"
                placeholder="Address (optional)"
            />
            <Input value={city} onChange={(e) => setCity(e.target.value)} type="city" placeholder="City (optional)" />
            <Input
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                width="w-1/2"
                type="country"
                placeholder="Country (optional)"
            />
            <Input
                value={postalCode}
                onChange={(e) => setPostalCode(e.target.value)}
                width="w-1/2"
                type="postalCode"
                placeholder="PostalCode (optional)"
            /> */}
            <p className="p-2 text-xs sm:text-sm md:text-base w-full text-center">
                already have an account{" "}
                <span
                    className="text-primary cursor-pointer"
                    onClick={() => {
                        setLoginForm(true);
                        setPassword("");
                    }}
                >
                    login
                </span>{" "}
                instead.
            </p>
            <button
                disabled={isLoading}
                type="submit"
                className="bg-primary hover:bg-secondary text-white rounded-lg p-2 my-4 w-full font-semibold text-center"
            >
                {isLoading ? "Processing..." : "Signup"}
            </button>
        </form>
    );
};
